import { useQuery } from '@tanstack/react-query';
import { getPointService } from '../../../domains/point';

const isResultOk = (res: any) => res?.result_code === '200' || res?.resultCode === 200;

interface Options {
  transaction_type?: 'EARN' | 'USE' | 'REFUND' | string;
  start_date?: string;
  end_date?: string;
  limit?: number;
  offset?: number;
  active?: boolean;
}

/**
 * 약국 포인트 거래 내역 조회 (이벤트 지급내역 / 포인트 관리 페이지에서 공유).
 */
export const usePointDistributions = (
  brn: string | null | undefined,
  params: Options = {},
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ['point-distributions', brn, params],
    enabled: !!brn && enabled,
    queryFn: async () => {
      const res = await getPointService().getPharmacyTransactions(brn, params);
      if (!isResultOk(res)) return { items: [], total: 0, summary: {} };
      return {
        items: (res?.data?.items ?? []) as any[],
        total: (res?.data?.total ?? 0) as number,
        summary: (res?.data?.summary ?? {}) as Record<string, any>,
      };
    },
  });
};
